import React, { ReactNode } from 'react'

export interface SettingsWrapperProps {
  children: ReactNode
}

export const SettingsWrapper: React.FC<SettingsWrapperProps> = ({
  children,
}: SettingsWrapperProps) => {
  return (
    <div
      className={
        'bg-background-secondary flex h-full w-full flex-col gap-7 overflow-x-hidden rounded-md p-5'
      }
    >
      {children}
    </div>
  )
}
